module.exports = __webpack_public_path__ + "img/l-cb6-110-2.503fbc02.gif";